import { create } from 'zustand';

/**
 * App auto-update state (paired with services/updateService.js). Driven by the
 * useAppUpdates hook. Setters mirror React useState semantics (value or updater).
 */
const initialState = {
  updateInfo: null,
  updateModalOpen: false,
  updateInstalling: false,
  updateError: '',
};

const setter = (set, key) => (value) =>
  set((state) => ({ [key]: typeof value === 'function' ? value(state[key]) : value }));

export const useUpdateStore = create((set) => ({
  ...initialState,
  setUpdateInfo: setter(set, 'updateInfo'),
  setUpdateModalOpen: setter(set, 'updateModalOpen'),
  setUpdateInstalling: setter(set, 'updateInstalling'),
  setUpdateError: setter(set, 'updateError'),
  reset: () => set({ ...initialState }),
}));
